import group from "./undo_group";
import {eachRange} from "../helpers/column_names";
import {setSpanCss} from "./spans";
import {conditions} from "../helpers/conditional";
import {getType} from "./types";
import * as arr from "../helpers/array";
import {getSheet} from "../sheets";

export function init(view){
	view.conditions = {
		_empty:true,
		_pull: {},
		handlers: createRules(),
		add: function(r, c, cond, val, style, page){
			add.apply(this, [view, r, c, cond, val, style, page]);
		},
		update: function(r, c, data, page){
			update.apply(this, [view, r, c, data, page]);
		},
		remove: function(r, c, page){
			remove.apply(this, [view, r, c, page]);
		},
		get: function(r, c, page){
			return get.apply(this, [view, r, c, page]);
		},
		parse: function(data, page){
			parse.apply(this, [view, data, page]);
		},
		serialize: function(page){
			return serialize.apply(this, [view, page]);
		},
		clear: function(page){
			clear.apply(this, [view, page]);
		}
	};

	view.attachEvent("onConditionSet", (data) => _setCondition(view, data));

	view.attachEvent("onUndo", (type_action, row, column, value) => {
		if(type_action == "condition")
			_undoCondition(view, row, column, value);
	});

	view.attachEvent("onDataSerialize", (data) => _serialize(view, data));
	view.attachEvent("onDataParse", (data) => _parse(view, data));

	view.attachEvent("onReset", () => view.conditions.clear() );

	view.attachEvent("onAction", (action, p)=> {
		if(action == "before-grid-change")
			updatePosition(view, p.name, p.inc, p.data, p.start);
	});

	reset(view);
}

function createRules(){
	const rules = webix.copy(conditions);
	rules.number = rules.number.concat([
		{ id:"between", handler: function(a, b){
			return (!b.start || a > b.start) && (!b.end || a < b.end);
		}},
		{ id:"notBetween", handler: function(a, b){
			return (!b.start || a <= b.start) || (!b.end || a >= b.end);
		}}
	]);
	return rules;
}

function getCellValue(view, value){
	if(isNaN(value*1)){
		if (value.charAt(0) == "=" && value.length > 1){
			value = view._mData.getStore().exec(value.substring(1), view._mPage.getContext());
			if(value === null)
				value = "";
		}
	}
	else {
		value = value*1;
	}
	return value;
}

function reset(view){
	view.conditions.clear();
}

function _setCondition(view, data){
	group.set(function(){
		view.eachSelectedCell((cell) => {
			const collection = view.conditions.get(cell.row, cell.column);
			if(collection)
				for (let i = 0; i < collection.length; i++)
					setSpanCss(view, cell.row, cell.column, collection[i][2], false);
			_changeCondition("update", cell.row, cell.column, (collection||null), data, view);
		});
	});
	view.refresh();
}

function _undoCondition(view, row, column, value){
	if(view.conditions.get(row, column))
		view.conditions.remove(row, column);
	if(value)
		view.conditions.update(row, column, value);
}

function _serialize(view, obj){
	obj.conditions = view.conditions.serialize();
}

function _parse(view, obj){
	view.conditions.parse(obj.conditions);
}

export function getConditionCss(view, row, column, rendered){
	let css = "";

	if (!view.conditions._empty){
		const collection = view.conditions.get(row, column);
		if(collection){
			const span = view.$$("cells").getSpan(row, column);
			let value = view.getCellValue(row,column,false);
			if(!value && value !== 0)
				value = "";

			let type = getType(view, row, column);
			if(!type || type == "string")
				type = "text";

			for (let i = collection.length - 1; i >= 0; i--){
				let currentValue = value;
				const rule = collection[i][0];
				const handlers = view.conditions.handlers;
				let handler;

				let checkOrder = ["text", type, "number", "date"];
				checkOrder = checkOrder.filter((v, i) => checkOrder.indexOf(v) == i);

				for(let k = 0; k < checkOrder.length; k++){
					const checkType = checkOrder[k];

					handler = arr.find(handlers[checkType], obj => obj.id == rule);
					if(handler){
						handler = handler.handler;
						if(checkType == "text" && rule != "equal" && rule != "notEqual")
							currentValue = rendered;
						break;
					}
				}

				let compare = collection[i][1];
				if(webix.isArray(compare))
					compare = {
						start: getCellValue(view, compare[0]),
						end: getCellValue(view, compare[1])
					};
				else
					compare = getCellValue(view, compare);

				if(!css && handler && handler(currentValue, compare)){
					css = collection[i][2];
					if(!span)
						break;
					setSpanCss(view, row, column, collection[i][2], true);
				}
				else
					setSpanCss(view, row, column, collection[i][2], false);
			}
		}
	}
	return css;
}


function addEmptyCollection(pull, row, column, state){
	state._empty = false;
	if(!pull[row])
		pull[row] = {};
	if(!pull[row][column])
		pull[row][column] = [];
	return pull[row][column];
}


function parse(view, data, page){
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet)
			sheet.content.conditions = data;
	}
	else{
		//backward compatibility
		const oldConditions = {
			">": "greater",
			"<": "less",
			"=": "equal",
			"!=": "notEqual",
			"<>": "between"
		};

		this._empty = true;
		if (!data) return;

		let i = data.length;
		while(i--){
			const c = data[i];
			const collection = addEmptyCollection(this._pull,c[0],c[1],this);
			c[2] = oldConditions[ c[2] ] || c[2];
			collection.push([c[2],c[3],c[4]]);
		}
	}
}

function clear(view, page){
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet)
			sheet.content.conditions = [];
	}
	else
		this._pull = {};
}

function update(view, row, column, newData, page){
	newData.map(item => _normalizeValue(view, item));

	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet){
			remove(view, row, column, page);

			if(!sheet.content.conditions)
				sheet.content.conditions = [];

			newData.forEach(condition => {
				sheet.content.conditions.push([row, column, ...condition]);
			});
		}
	}
	else{
		addEmptyCollection(this._pull, row, column, this);
		this._pull[row][column] = newData;
	}
}

function get(view, row, column, page){
	let condition;
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet && sheet.content.conditions){
			const conditions = webix.copy(sheet.content.conditions);
			let index;
			let conditionArr = [];
			while((index = arr.findIndex(conditions, condition => condition[0] == row && condition[1] == column)) != -1){
				conditionArr.push(conditions[index].slice(2,5));
				conditions.splice(index, 1);
			}
			if(conditionArr.length)
				condition = conditionArr;
		}
	}
	else if(this._pull[row] && this._pull[row][column])
		condition = this._pull[row][column] || null;
	return condition || null;
}

function add(view, row, column, condition, value, style, page){
	const newCondition = _normalizeValue(view, [condition, value, style]);

	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet){
			if(!sheet.content.conditions)
				sheet.content.conditions = [];
			sheet.content.conditions.push([row, column, ...newCondition]);
		}
	}
	else
		addEmptyCollection(this._pull, row, column, this).push(newCondition);
}

function remove(view, row, column, page){
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet && sheet.content.conditions){
			let index;
			while((index = arr.findIndex(sheet.content.conditions, condition => condition[0] == row && condition[1] == column)) != -1){
				sheet.content.conditions.splice(index, 1);
			}
		}
	}
	else{
		const collection = this.get(row, column);
		if(collection)
			delete this._pull[row][column];
	}
}

function serialize(view, page){
	let data = [];
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet && sheet.content.conditions)
			data = sheet.content.conditions;
	}
	else{
		for(let row in this._pull)
			for(let column in this._pull[row])
				for(let i = 0; i < this._pull[row][column].length; i++){
					const condition = this._pull[row][column][i];
					data.push([row, column, condition[0], condition[1], condition[2]]);
				}
	}
	return data;
}

function updatePosition(view, name, inc, data, start){
	let conditions = data.conditions,
		i = conditions.length;

	if(inc){
		while(i--){
			let [row,column] = conditions[i];
			if(name == "row" && row>= start.row || name == "column" && column >= start.column){
				if (name == "row"){
					if (row < start.row - inc)	//delete lock mark if row was deleted
						conditions.splice(i,1);
					else						//update mark position if upper row was deleted
						conditions[i][0] = row*1 + inc;
				} else if (name == "column"){
					if (column < start.column - inc){
						conditions.splice(i, 1);
					} else 
						conditions[i][1] = column*1 + inc;
				}
			}
		}
	}
}

export function clearConditionalFormats(view, range, page){
	group.set(function(){
		range.split(";").forEach(ref => {
			eachRange(ref, view, function(view, cell){
				const condition = view.conditions.get(cell.row, cell.column, page);
				if(condition)
					_changeCondition("remove", cell.row, cell.column, condition, null, view, page);				
			});
		});
	});
}

export function pasteCondition(view, extra, row, col, cutted){
	const condition = extra.condition;
	const collection = view.conditions.get(row,col);
	_changeCondition("update", row, col, (collection||null), condition, view);
	if(cutted === 1)
		_changeCondition("remove", extra.row, extra.col, condition, null, view);
}

export function _changeCondition(name, row, column, oldCondition, newCondition, view, page){
	page = page || view.getActiveSheet();
	if (view.callEvent("onBeforeConditionSet", [row, column, oldCondition, newCondition, page])){
		view.conditions[name].apply(view.conditions, [row, column, name == "remove" ? page : newCondition]);
		view.callEvent("onAfterConditionSet", [row, column, oldCondition, newCondition, page]);
	}
}

function _normalizeValue(view, condition){
	const val = condition[1];
	if(val[0] == "=")
		condition[1] = view._mData.getStore().parse(val).source; //fixes formula
	return condition;
}